module.exports = __webpack_public_path__ + "img/birthday_bike_holiday.f53267a0.jpg";